module.exports = __webpack_public_path__ + "static/img/case_01.b578951.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case_01.jpg
// module id = 2nHS
// module chunks = 0